import { lazy, FC, Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { MasterLayout } from '../../_metronic/layout/MasterLayout';
import TopBarProgress from 'react-topbar-progress-indicator';
import { DashboardWrapper } from '../pages/dashboard/dashboard/DashboardWrapper';
import { MenuTestPage } from '../pages/MenuTestPage';
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils';
import { WithChildren } from '../../_metronic/helpers';

const PrivateRoutes = () => {
  const HeThongPage = lazy(() => import('../pages/HeThongPage'));
  const DanhMucPage = lazy(() => import('../pages/DanhMucPage'));
  const ThongKeBaoCao = lazy(() => import('../pages/ThongKeBaoCao'));
  const HoSoPage = lazy(() => import('../pages/HoSoPage'));
  const TaiLieuPage = lazy(() => import('../pages/TaiLieuPage'));
  const MuonTraPage = lazy(() => import('../pages/MuonTraPage'));
  const TaiLieuMinhChungPage = lazy(() => import('../pages/TaiLieuMinhChungPage'));

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />

        <Route
          path='quan-ly-ho-so/*'
          element={
            <SuspensedView>
              <HoSoPage />
            </SuspensedView>
          }
        />

        <Route
          path='quan-ly-tai-lieu/*'
          element={
            <SuspensedView>
              <TaiLieuPage />
            </SuspensedView>
          }
        />

        <Route
          path='quan-ly-muon-tra/*'
          element={
            <SuspensedView>
              <MuonTraPage />
            </SuspensedView>
          }
        />

        <Route
          path='tai-lieu-minh-chung/*'
          element={
            <SuspensedView>
              <TaiLieuMinhChungPage />
            </SuspensedView>
          }
        />

        <Route
          path='he-thong/*'
          element={
            <SuspensedView>
              <HeThongPage />
            </SuspensedView>
          }
        />
        <Route
          path='danh-muc/*'
          element={
            <SuspensedView>
              <DanhMucPage />
            </SuspensedView>
          }
        />
        <Route
          path='bao-cao/*'
          element={
            <SuspensedView>
              <ThongKeBaoCao />
            </SuspensedView>
          }
        />
        <Route index element={<Navigate to='/admin/tai-lieu-minh-chung' />} />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--kt-primary');
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
